import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'app-checkbox-button',
  templateUrl: './checkbox-button.component.html',
  styleUrls: ['./checkbox-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatCheckboxModule, FormsModule],
})
export class CheckboxButtonComponent {
  labelPosition: 'before' | 'after' = 'before';
  @Input() disabled = false;

  checkedValue = false;
  @Input()
  get checked() {
    return this.checkedValue;
  }
  set checked(val) {
    this.checkedValue = val;
    this.checkedChange.emit(this.checkedValue);
  }

  @Output() checkedChange = new EventEmitter<boolean>();
}
